import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'overlay',
    theme => `
		display: block;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		padding: 16px 0;
		text-align: center;
		overflow: hidden;
		z-index: 5;
		background-color: ${theme.color.text.white};
		opacity: 0.9;
		box-sizing: border-box;
	`
  ]
]);
